import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();



{/* <Box sx={{
        padding: 1,
        borderRadius: 1,
        border: '1px solid #ddd',
        marginBottom: 3,
        display: 'flex',
        backgroundColor: gradientColor(overallCompletionPercentage),
        background: gradientColor(overallCompletionPercentage),
      }}>
        <Box sx={{ width: '20%', padding: 0, paddingTop: "30px" }}>
          <Typography variant="h5">
            ECTS Deployment
          </Typography>
        </Box>
        <Box sx={{ width: '80%', padding: 2 }}>
          <Table size="small" aria-label="simple table" sx={{ width: '100%' }}>
            <TableHead>
              <TableRow>
                <TableCell>Plan Start Date</TableCell>
                <TableCell>Plan End Date</TableCell>
                <TableCell>Planned Duration</TableCell>
                <TableCell>Actual Start</TableCell>
                <TableCell>Actual End</TableCell>
                <TableCell>Actual Duration</TableCell>
                <TableCell>Completion</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableCell>29 March 25</TableCell>
              <TableCell>29 March 25</TableCell>
              <TableCell>03:24</TableCell>
              {firstTaskStartTime !== 'NA' && firstTaskStartTime && (
                  <TableCell>{firstTaskStartTime}</TableCell>
              )}
              {lastTaskEndTime !== 'NA' && lastTaskEndTime && (
                  <TableCell>{lastTaskEndTime}</TableCell>
              )}
              {totalTimeTaken !== 'NA' && totalTimeTaken && (
                  <TableCell>{totalTimeTaken}</TableCell>
              )}
              {overallCompletionPercentage > 0 && overallCompletionPercentage !== 'NA' && (
                  <TableCell>{overallCompletionPercentage}%</TableCell>
              )}
            </TableBody>
          </Table>
        </Box>
      </Box> */}
